import { gsapSingleton } from "../gsap";
const gsap = gsapSingleton();
import Component from '../models/Component';
import { ScrollTrigger } from "gsap/ScrollTrigger";


export default class StickyColumn extends Component {
    constructor(element, context) {
        super(element, context);
        if (!element || window.innerWidth < 768) return;

        setTimeout(() => {
            gsap.registerPlugin(ScrollTrigger);
            const container = this.element;
            const image = container.find('.image-container')
            const containerHeight = container.height();
            const imageHeight = image.height();
            const difference = containerHeight - imageHeight;
            
            if (difference > 0) {
                ScrollTrigger.create({
                    trigger: container,
                    start: "top 10%",
                    end: `+=${difference}`, 
                    pin: image,
                });
            }
        }, 200);
    }
}